export default __webpack_public_path__ + "static/media/pj-https-rn.05c837ad.png";